/**
 * created by hezq on 2022-10-10
 *
 * description: 接口配置
 *
 */

const api = {
	// 页面访问上报 【POST】
	reportPageView: '/page/behavior/submit',
	// 事件行为上报 【POST】
	reportEvent: '/page/event/submit'
}

export default api



// WEBPACK FOOTER //
// ./src/api.js